import { useEffect, useState } from 'react';
import { envMockedApi, isPanelUrlIncludesEventOrigin } from '@repo/env';
var internalHashMock = null;
if (envMockedApi()) {
    import('./internal-hash.mock').then(function (module) {
        internalHashMock = module.internalHashMock;
    });
}
export var useGetHashFromIframe = function () {
    var _a = useState(undefined), iframeHash = _a[0], setIframeHash = _a[1];
    var _b = useState('idle'), hashStatus = _b[0], setHashStatus = _b[1];
    useEffect(function () {
        setHashStatus('pending');
        window.parent.postMessage({ type: 'READY' }, '*');
    }, []);
    useEffect(function () {
        if (envMockedApi()) {
            setIframeHash(internalHashMock || '');
            setHashStatus('success');
            return;
        }
        if (iframeHash !== undefined)
            return;
        function setHashFromIframe(evt) {
            var _a;
            if (!isPanelUrlIncludesEventOrigin(evt.origin)) {
                setHashStatus('error');
                throw Error('application not embeddable at this URL');
            }
            else if (typeof ((_a = evt.data) === null || _a === void 0 ? void 0 : _a.hash) === 'string') {
                setHashStatus('success');
                setIframeHash(evt.data.hash);
            }
            else {
                setHashStatus('error');
                throw Error('no hash found for this URL');
            }
        }
        window.addEventListener('message', setHashFromIframe, false);
        return function () {
            window.removeEventListener('message', setHashFromIframe);
        };
    }, [iframeHash]);
    return { iframeHash: iframeHash, hashStatus: hashStatus };
};
